module.exports = __webpack_public_path__ + "static/media/arquitetura-icon.ec0dc348.svg";